import { render, staticRenderFns } from "./WhitelabelColor.vue?vue&type=template&id=1edb77f9&scoped=true&"
import script from "./WhitelabelColor.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelColor.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelColor.vue?vue&type=style&index=0&id=1edb77f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb77f9",
  null
  
)

export default component.exports